import { Injectable } from '@angular/core';

interface IErrObj{
  message: string;
  img?:string | null;
  status?:number;
}

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlingService {

  constructor() { }

  getErrorObj(error:any):IErrObj{
    if(error.status == 400 || error== 400)
      return typeof this.getBadRequestErr(error).message == 'string' ? this.getBadRequestErr(error) : {...this.getBadRequestErr(error),message : 'خطایی رخ داده است'};
    if(error.status == 401 || error== 401)
      return this.getUnauthorizedErr(error);
    if(error.status == 403 || error== 403)
      return this.getForbiddenErr(error);
    if(error.status == 404 || error== 404)
      return this.getNotFoundErr(error);
    if(error.status== 406 || error== 406 ||error.status==423 || error== 423 ||error.status==429 || error== 429 )
      return this.getTooManyReqErr(error);
    if(error.status==0 || error == 0)
      return this.noInternet(error)
    if(error.status== 500 || error==500)
      return this.getNoResponseErr(error);
    if(error.status == 502 || error == 502)
      return this.getBadGatway(error);
    else return {
        message: 'خطایی رخ داده است',
        img:'net',
        status:0
      }
  }

  getBadRequestErr(error:any):IErrObj{
    let errObj:IErrObj = {
      status:400,
      message:this.getMessage(error),
      img:'400',
    }
    return errObj;
  }

  getUnauthorizedErr(error:any):IErrObj{
    let errObj:IErrObj = {
      status:401,
      message:this.getMessage(error),
      img:'401',
    }
    return errObj;
  }

  getForbiddenErr(error:any):IErrObj{
    let errObj:IErrObj = {
      status:403,
      message:this.getMessage(error),
      img:'',
    }
    return errObj;
  }

  getNotFoundErr(error:any):IErrObj{
    let errObj:IErrObj = {
      status:404,
      message:'محتوای مد نظر یافت نشد',//this.getMessage(error),
      img:'404blog',
    }
    return errObj;
  }

  getTooManyReqErr(error:any):IErrObj{//429 or 423 or 406 err
    let errObj:IErrObj = {
      status:406,
      message:this.getMessage(error),
      img:null,
    }
    return errObj;
  }

  getNoResponseErr(error:any):IErrObj{//0 or 500 err
    let errObj:IErrObj= {
      status:500,
      message: 'مشکلی در سرور ایجاد شده است',
      img:'500'
    }
    return errObj;
  }
  noInternet(error:any){
    let errObj:IErrObj= {
      status:0,
      message:'دسترسی شما به اینترنت قطع شده است',
      img:'net'
    }
    return errObj;
  }
  getBadGatway(error:any){
    let errObj:IErrObj= {
      status:502,
      message:'مشکلی در سرور ایجاد شده است',
      img:'502'
    }
    return errObj;
  }
  getMessage(error:any){
    if(typeof error.error == 'string') return error.error
    else if((typeof error.error === "object" || typeof error.error === 'function') && (error.error !== null)) {
      let errorMessage;
      let breakStatus = true;
      Object.keys(error.error).forEach(err=>{
        if(breakStatus){
          if(Array.isArray(error.error[err as keyof any])){
            let e = error.error[err as keyof any][0]
            errorMessage = e.message ? e.message : e
            breakStatus = false;
          }else {
            errorMessage = error.error[err as keyof any]
          }
        }
      })
      return errorMessage;
    }
    else if(Array.isArray(error.error)) return error.error[0]
    else return 'خطایی رخ داده است.'
  }
}